import { useState, useEffect, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ConsultaAPI } from '../../../../../shared/http-requests';
import DropDownSearch, { makeDataSource } from './DropDownSearch';

/**
 *
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param setCurso {function}
 * @returns {JSX.Element}
 * @constructor
 */
const DropDownInputCurso = forwardRef(({ setCurso }, ref) => {
    const [data, setData] = useState();
    const [pagination, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [selected, setSelected] = useState(0);

    /**
     * Busca o dado pelo id caso seja um acesso direto pela url
     */
    useEffect(() => {
        const curso = params.get('curso');

        if (curso) {
            ConsultaAPI.buscarCursoPorCodigo(curso)
                .then(response => {
                    const { data } = response;
                    if (data) {
                        const config = {
                            id: 'cod_departamento',
                            key: 'cod_departamento',
                            text: ({ cod_departamento, nome_departamento }) => {
                                return `${cod_departamento} - ${nome_departamento}`;
                            },
                            textToFind: 'nome_departamento',
                        };

                        const parsedData = makeDataSource([data], config);
                        setCurso(parsedData[0]);
                        setSelected(data?.cod_departamento);
                        setData(parsedData);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }else{
            buscaCursos();
        }
    }, []);

    const buscaCursos = (text = '', page = 1) => {
        setLoading(true);
        return ConsultaAPI.buscarCursos(text, page)
            .then(response => {
                const { data } = response;
                if (data) {
                    const { results, totalPages, currentPage } = data;
                    setPagination({ totalPages, currentPage });

                    const config = {
                        id: 'cod_departamento',
                        key: 'cod_departamento',
                        text: ({ cod_departamento, nome_departamento }) => {
                            return `${cod_departamento} - ${nome_departamento}`;
                        },
                        textToFind: 'nome_departamento',
                    };

                    setData(makeDataSource(results, config));
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.log(error);
            });
    };

    return (
        <DropDownSearch
            ref={ref}
            placeholder="Selecione um curso"
            loading={loading}
            customFilter
            data={data}
            value={selected}
            onChange={buscaCursos}
            onSelect={item => {
                setCurso(item);
            }}
            pagination={pagination}
        />
    );
});

export default DropDownInputCurso;
